/// <amd-module name="Core/Medius.Core.Web/Scripts/lib/domesticCommunications"/>

import {translate} from "Core/Medius.Core.Web/Scripts/lib/globalization";

export enum DomesticCommunicationType {
    Email = 0,
    EInvoicingNetwork = 1
}
export const DomesticCommunications = [
    { Name: translate('#Core/company/email'), Value: DomesticCommunicationType.Email },
    { Name: translate('#Core/company/eInvoicingNetwork'), Value: DomesticCommunicationType.EInvoicingNetwork }
];